import React from "react";

const ViewHeader = (props) => {

  return (
    <div className="header border-bottom">
      <span>{props.name}</span>
    </div>
  );
}

ViewHeader.defaultProps = {
  name: "Nome em branco"
};

export default ViewHeader;